import { z } from 'zod';
import { ALLOWED_UPLOAD_MIME, DOCUMENT_TYPES, FILE_STATUSES } from '../constants/enums';
import { uuidSchema } from './common';

/**
 * Загрузка идёт напрямую в MinIO по presigned PUT — файл не проходит
 * через API. Это снимает с Node нагрузку и лимиты на размер тела.
 * Схема: запросить ссылку → залить → подтвердить.
 */

export const uploadRequestSchema = z.object({
  candidateId: uuidSchema,
  documentType: z.enum(DOCUMENT_TYPES),
  fileName: z.string().trim().min(1).max(255),
  mimeType: z.enum(ALLOWED_UPLOAD_MIME),
  sizeBytes: z.number().int().positive().max(20 * 1024 * 1024, 'Файл больше 20 МБ'),
});

export const uploadTicketSchema = z.object({
  fileId: uuidSchema,
  uploadUrl: z.string().url(),
  /** Ключ объекта во временном бакете */
  objectKey: z.string(),
  expiresAt: z.string(),
});

export const uploadConfirmSchema = z.object({
  fileId: uuidSchema,
  /** SHA-256 от содержимого, посчитанный на клиенте — защита от подмены */
  checksum: z.string().length(64).optional(),
});

export const candidateFileSchema = z.object({
  id: uuidSchema,
  candidateId: uuidSchema,
  documentType: z.enum(DOCUMENT_TYPES),
  fileName: z.string(),
  mimeType: z.string(),
  sizeBytes: z.number().int(),
  status: z.enum(FILE_STATUSES),
  /** Ошибка обработки, если status = failed */
  errorMessage: z.string().nullable(),
  /** Ширина и высота — чтобы лайтбокс не прыгал при загрузке */
  width: z.number().int().nullable(),
  height: z.number().int().nullable(),
  pageCount: z.number().int().nullable(),
  uploadedBy: uuidSchema.nullable(),
  uploadedByName: z.string().nullable(),
  createdAt: z.string(),
});
export type CandidateFile = z.infer<typeof candidateFileSchema>;

/**
 * Ссылка на просмотр. Живёт минуты, выдаётся только после проверки права
 * document.view, и каждая выдача пишется в журнал доступа к ПДн.
 */
export const fileAccessSchema = z.object({
  url: z.string().url(),
  thumbnailUrl: z.string().url().nullable(),
  expiresAt: z.string(),
});

export const fileListQuerySchema = z.object({
  candidateId: uuidSchema,
  documentType: z.enum(DOCUMENT_TYPES).optional(),
});
